import {VuexModule, Module, Action, Mutation} from "vuex-module-decorators";
import Category from "@/model/category";


@Module({namespaced: true})
export default class CategoryModule extends VuexModule {
  public categories: Category[] = [];
  public subCategories: Category[] = [];

  @Mutation
  set(categories: Category[]): void {
    this.categories = categories;
  }

  @Mutation
  setSub(categories: Category[]): void {
    this.subCategories = categories;
  }

  @Action({rawError: true})
  setCategoryToList(categories: Category[]) {
    this.context.commit('set', categories);
  }

  @Action({rawError: true})
  setSubCategoryToList(categories: Category[]) {
    this.context.commit('setSub', categories);
  }

  @Mutation
  addCategories(category: Category): void {
    this.categories.push(category);
  }

  @Mutation
  addSubCategories(category: Category): void {
    this.subCategories.push(category);
  }

  @Action({rawError: true})
  addCategoryToList(category: Category) {
    this.context.commit('addCategories', category);
  }

  @Action({rawError: true})
  addSubCategoryToList(category: Category) {
    this.context.commit('addSubCategories', category);
  }

  @Mutation
  editCategory(category: Category): void {
    this.categories.map((item, key) => {
      if (item.identifier === category.identifier) {
        this.categories.splice(key, 1, category)
      }
    })
  }

  @Mutation
  editSubCategory(category: Category): void {
    this.subCategories.map((item, key) => {
      if (item.identifier === category.identifier) {
        this.subCategories.splice(key, 1, category)
      }
    })
  }

  @Action({rawError: true})
  editCategoryInList(category: Category) {
    this.context.commit('editCategory', category);
  }

  @Action({rawError: true})
  editSubCategoryInList(category: Category) {
    this.context.commit('editSubCategory', category);
  }

  @Action({ rawError: true })
  clear() {
    this.context.commit("set", []);
  }

  @Action({ rawError: true })
  clearSub() {
    this.context.commit("setSub", []);
  }

  get getCategories(): Category[] {
    return this.categories;
  }

  get getSubCategories(): Category[] {
    return this.subCategories;
  }
}
